import { createApp } from 'vue'
import App from './App.vue'
import Vue3TouchEvents from "vue3-touch-events";
import axios from 'axios'
import VueAxios from 'vue-axios'

createApp(App).use(Vue3TouchEvents).use(VueAxios,axios).mount('#app');
